import React from "react";
import styles from "./Backdrop.module.css";

const Backdrop = (props: { style: any; onClose: () => void }) => {
  return (
    <div
      style={props.style}
      className={styles.backdrop}
      onClick={props.onClose}
    />
  );
};

export default Backdrop;
